import {useState} from 'react'
import axios from 'axios'
import {API_ENDPOINTS} from '../../../../constants/apiConstants'
import {CardElement, useStripe, useElements} from '@stripe/react-stripe-js'
import {toast} from 'react-toastify'
import {stripePromise} from '../../helper'

const AddCardForm = ({onComplete}) => {
  const stripe = useStripe()
  const elements = useElements()
  const [cardholderName, setCardholderName] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!stripe || !elements) return

    setLoading(true)
    try {
      const res = await axios.post(API_ENDPOINTS.CREATE_SETUP_INTENT())
      const result = await stripe.confirmCardSetup(res?.data?.data.clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
          billing_details: {
            name: cardholderName,
          },
        },
      })

      if (result.error) {
        toast.error(result.error.message)
      } else {
        toast.success('Card added successfully')
        onComplete()
      }
    } catch (err) {
      toast.error('Error adding card')
    } finally {
      setLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className='p-3 border rounded shadow-sm'>
      <div className='mb-3'>
        <input
          type='text'
          className='form-control'
          placeholder='Card holder name'
          value={cardholderName}
          onChange={(e) => setCardholderName(e.target.value)}
          required
        />
        <small className='text-muted'>Card Holder Name must start with a letter</small>
      </div>
      <div className='mb-3'>
        <CardElement
          stripe={stripePromise}
          // options={{hidePostalCode: true}}
          className='form-control p-2 border'
        />
      </div>
      <button type='submit' className='btn btn-primary w-100' disabled={loading}>
        {loading ? 'Adding...' : 'Add Card'}
      </button>
    </form>
  )
}

export default AddCardForm
